import confetti from 'canvas-confetti';

// Антверпен-эстетика: вместо радужных конфетти — медленно оседающие перья
// и угольно-кремовые частицы. Перо — прямой мотив Ann Demeulemeester.
const INK = ['#14130F', '#23271D', '#4F5A43', '#736E62', '#EEEBE3'];

let featherShape: ReturnType<typeof confetti.shapeFromText> | null = null;
function feather() {
  if (!featherShape) {
    try {
      featherShape = confetti.shapeFromText({ text: '🪶', scalar: 2 });
    } catch {
      featherShape = null;
    }
  }
  return featherShape;
}

export function celebrateSmall(): void {
  // скупой росчерк — несколько угольных частиц, без буйства
  confetti({
    particleCount: 14,
    spread: 50,
    startVelocity: 24,
    gravity: 0.8,
    ticks: 140,
    origin: { y: 0.72 },
    colors: INK,
    scalar: 0.9,
  });
}

export function celebrateBig(): void {
  // медленный дождь перьев — тягучая, почти меланхоличная радость
  const f = feather();
  const duration = 2600;
  const end = Date.now() + duration;

  (function frame() {
    confetti({
      particleCount: f ? 2 : 4,
      startVelocity: 0,
      gravity: 0.32,
      drift: 0.6,
      ticks: 320,
      spread: 80,
      origin: { x: Math.random() * 0.6 + 0.2, y: -0.1 },
      colors: INK,
      ...(f ? { shapes: [f], scalar: 2.2, flat: true } : { scalar: 1 }),
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
